var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _rect, _ellipse2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundneck01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-101,.cls-100,.cls-97{fill:#fff;}.cls-101,.cls-99,.cls-98,.cls-97{stroke:#010101;stroke-miterlimit:10;}.cls-101,.cls-98{stroke-dasharray:2.7;}.cls-99,.cls-98{fill:none;}.cls-99{stroke-width:3px;}.cls-97{stroke-width:2.7px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M366.4,182.14V291.67c-36.56,20.26-93,33.23-156.22,33.23-59.9,0-113.63-11.63-150.21-30V180.07L109.19,161c.64-.17,1.29-.35,1.93-.5,29.19-7.37,63-11.6,99.06-11.6,38.53,0,74.51,4.81,105,13.17C334.77,167.42,352.1,174.21,366.4,182.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M370.1,180.07V353.44H55.43V180.07L106,161l2-.75v.25c.15,11.2,5.68,20.93,11.86,31.08,17,28,54.89,35.3,76.64,37.13,4.88.43,8.94.56,11.79.61.14,0,.28,0,.4,0,1,0,1.85,0,2.49,0,.13,0,.25,0,.38,0l1.1,0h.3l1.1,0h.4c2.11,0,6.29,0,11.79-.37.92-.07,1.88-.14,2.87-.24,21.74-1.83,59.65-9.13,76.64-37.13,5.88-9.69,11.19-19,11.8-29.51,0-.61.06-1.21.06-1.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M59.77,180.07l51.15-19.82c.06,11.31,5.49,21.1,11.55,31.33,16.54,28,53.45,35.3,74.63,37.13,4.75.43,8.71.56,11.48.61.14,0,.27,0,.39,0l1.07,0h.29l1.07,0c.12,0,.24,0,.37,0l1.07,0h.29l1.07,0h.39c2.77,0,6.73-.18,11.48-.61V229c.9-.07,1.83-.14,2.8-.24,21.17-1.83,58.08-9.13,74.63-37.13,6.06-10.23,11.49-20,11.55-31.33l51.15,19.82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M62.77,182.12l45.4-17.6c1.15,10,6,18.94,11.72,28.59,17.29,29.27,55.63,36.74,77,38.59,5.83.52,10.53.63,13.45.63,1.33,0,2.19,0,2.5,0h.34c.36,0,1.22,0,2.54,0,2.92,0,7.62-.11,13.46-.63,21.31-1.85,59.65-9.32,76.95-38.59,5.71-9.65,10.56-18.58,11.71-28.59l45.41,17.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M193.38,353.44l0-3,.88-119,0-2.75a142.26,142.26,0,0,0,14.28.61c.14,0,.27,0,.39,0l1.07,0h.29l1.07,0c.12,0,.24,0,.37,0,.63,0,1.45,0,2.43,0h.39c2.77,0,6.73-.18,11.48-.61V229l0,3L227,350.44l0,3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M196.4,350.44,197.27,232c4.34.3,7.86.37,10.22.37,1.32,0,2.19,0,2.5,0h.33c.36,0,1.23,0,2.55,0,2.36,0,5.88-.07,10.22-.37L224,350.44"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.18,
    cy: 247.71,
    rx: 6.71,
    ry: 6.41
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 209.49,
    y: 239,
    width: 1.39,
    height: 17.84
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.18,
    cy: 331.71,
    rx: 6.71,
    ry: 6.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209.49,
    y: 323,
    width: 1.39,
    height: 17.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundneck01);
export default __webpack_public_path__ + "static/media/ROUND NECK-01.5a5094d2a30c93cc7523b872028f4496.svg";
export { ForwardRef as ReactComponent };